Object.defineProperty(exports, "__esModule", {
  value: true,
});

exports.createAccountURL = "account/accounts";
exports.loginAccountURL = "login/login";
exports.urlHeaderTypeJSON = "application/json";
exports.postHttpRequest = "POST";

// Customizable Area Start
exports.clientID =
  "503705875194-km0gm7epjkp890unsk30blim76mmu8if.apps.googleusercontent.com";
exports.facebookButtonText = "Sign up With Facebook";
exports.googleButtonText = "Sign up With Google";
exports.signUpButtonText = "Sign up with email and password";

exports.loginFacebookButtonText = "Log in With Facebook";
exports.loginGoogleButtonText = "Log in With Google";
exports.loginButtonText = "Log in with email and password";

exports.errorTitle = "Error";
exports.errorDescription = "#Error fetching data: ";

exports.signUpTitleText = "Sign up";
exports.signUpBodyText = "Value proposition: why users should sign up.";

exports.logInTitleText = "Log In";
exports.logInBodyText = "The reason why we require login.";
exports.loginFailed = "Something went wrong!"
exports.orText = "or";
exports.facebookBaseUrl = "https://graph.facebook.com/v2.5/me?fields=email,name,friends&access_token=";
exports.facebookApiMethod = "GET";
exports.facebookAppId = "170982444234877";

exports.footerHelperText = "If you're a prior camp attendee or registrant, you're already in our system, so sign in using the credentials provided previously. ";
exports.ownTheFutureText = "Own the future.";

exports.googleSsoLoginPostEndPoint = "bx_block_login/logins/sso_operation";
exports.ssoLoginErrorMsg = "Something went wrong, Please try again!";
// Customizable Area End